import { ThemeProvider, createTheme } from "@mui/material/styles";
import React from "react";
import { TopNav } from ".";
import Content from "./Content";
import Footer from "./Footer";
import Header from "./Header";
import ActionBar from "./components/ActionBar";
import Breadcrumb from "./components/Breadcrumb";
import { SideNav } from "./sidenav/SideNav";
export const themeAppFrame = createTheme({});
const Frame = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ThemeProvider, { theme: themeAppFrame },
            React.createElement(Header, { appModel: props.appModel },
                React.createElement(Breadcrumb, { appModel: props.appModel }, props.breadcrumbParts),
                React.createElement(SideNav, { appModel: props.appModel }, props.sidenavElements),
                React.createElement(TopNav, { appModel: props.appModel }, props.topNavElements),
                React.createElement(ActionBar, { appModel: props.appModel, hideDefaultActions: props.hideDefaultActions }, props.actions)),
            React.createElement(Content, null, props.children),
            React.createElement(Footer, { appModel: props.appModel }))));
};
export default Frame;
